import React from 'react';
import {Link} from 'react-router';
import PropTypes from 'prop-types';

const LinkComp = (props) => {
	function _handleClick(e) {
		window.scrollTo(0, 0);
		if (props.onClick) {
			props.onClick(e);
		}
	}

	return <Link {...props} onClick={_handleClick}/>;
};

LinkComp.propTypes = {
    onClick: PropTypes.func,
};

export default LinkComp;